import React, { useState } from "react";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { buildCompanyLogoUrl } from "utils/logo";

// Supplier ID -> domain map
const supplierLogos = {
  "C4645DA4-BA8F-4973-9AAE-532FB0505B07": "aepenergy.com",
  "32A9E1A8-DF19-4B70-8793-0D1695FD90DF": "ammper.com",
  "64304CDD-0011-4A7E-B0E5-147C9FF78675": "apge.com",
  "6D13B50B-3260-4279-A3B5-1D7E68091ABB": "atlanticenergyco.com",
  "F232C168-5F59-4C6B-B80B-7E0EE34A259E": "branchenergy.com",
  "EE091DE1-695B-4257-B491-688FEC24D852": "catalystpower.com",
  "21043EB4-B9A4-4BBC-9CAD-26C15DFE25EC": "championenergyservices.com",
  "41C9C9C8-F2E6-4B82-BDBE-C55243D41803": "chariotenergy.com",
  "6CE62215-20C0-434E-8AF6-4AF301016DDB": "cleanskyenergy.com",
  "875C7031-92CB-4ABE-811F-1733A049EBF4": "constellation.com",
  "60BB3692-528D-4B1A-8AF9-07E46F55B2B4": "directenergy.com",
  "A837B820-C9CF-4295-8275-E351445959A4": "dynegy.com",
  "6BD2C20F-0CE3-4B00-ACDE-63569A4273A1": "engie.com",
  "702D1F26-0DDC-4A61-AC9F-62C96FE1C136": "firstpointpower.com",
  "958A3FC6-21D4-430F-8834-209E801A7C39": "freepoint.com",
  "3277A3E0-95BC-425C-B729-CC7AE6DF81AD": "gassouth.com",
  "3B0CD20F-FB31-4797-B510-185F51A0DFA1": "genieretail.com",
  "D2BE4A8A-780F-4DB1-9EDC-760E9F3222DD": "gexaenergy.com",
  "052A4363-A6F9-4EF4-9303-B0580FCCE290": "homefieldenergy.com",
  "120DE132-5154-44C1-BC5E-42AEC6ED6909": "hudsonenergy.net",
  "3BAE837B-8BC7-4574-A32F-4AD870C6580D": "indraenergy.com",
  "D1255099-73AB-4D12-B466-542D75DD221B": "ironhorsepowerservices.com",
  "8F63A33F-41DB-4129-B0B4-1A59370D0403": "newwaveenergy.com",
  "FF2AAC3F-BDC8-4E19-AB14-16E2D2A55573": "nexteraenergy.com",
  "C9BC8032-1424-4E15-86B7-8BCD426682BB": "nordicenergy-us.com",
  "38E36FC8-0C9A-4774-9632-555E6C28BB37": "nrg.com",
  "02E684F6-4291-4B71-A37D-C03382FE38E2": "santannaenergyservices.com",
  "A638D4CA-A76A-4861-B1C1-996796FAE4F6": "sfeenergy.com",
  "9FEDD1C8-EB97-404C-9E3C-7A267473CCD4": "sparkenergy.com",
  "374BD0E8-60AC-4A6A-BE86-EF7191E47047": "spragueenergy.com",
  "63A4EA14-1C3C-440A-B764-A070BE7C93A7": "summerenergy.com",
  "9C5337FD-2030-4510-BD57-C736BFDD8E35": "txu.com",
};

const getLogoValue = (supplierId, supplierName = "", fallback = "") => {
  const key = (supplierId || "").toUpperCase();
  const mappedDomain = supplierLogos[key];

  if (mappedDomain !== null && mappedDomain !== undefined && mappedDomain !== "") {
    return mappedDomain;
  }

  return supplierName || fallback;
};

const SupplierLogo = ({ supplierId, supplierName = "", fallback = "nrg.com", size = 45, className = "" }) => {
  const [error, setError] = useState(false);

  const logoValue = getLogoValue(supplierId, supplierName, fallback);
  const idSafe = (supplierId || logoValue || "unknown").replace(/[^a-z0-9]/gi, "");
  const overlay = <Tooltip id={`tt-${idSafe}`}>{""}</Tooltip>;
  const containerEl = typeof document !== "undefined" ? document.body : undefined;

  const src = error
    ? ""
    : buildCompanyLogoUrl(logoValue);

  return (
    // <OverlayTrigger placement="bottom" overlay={overlay} container={containerEl}>
    <>
      {error ? (
        <div
          style={{
            width: size,
            height: size,
            borderRadius: "6px",
          }}
        />
      ) : (
        <Image
          src={src}
          className={`${size === 50 ? "logo-50" : "logo-45"} ${className}`}
          alt={logoValue}
          onError={() => setError(true)}
          style={{ width: size, height: size, objectFit: "contain" }}
        />
      )}
    </>

    // </OverlayTrigger>
  );
};

export default SupplierLogo;
